import type { StateBreakdownItem } from '../../api/types'
import { formatHours, formatPercent } from '../../utils/format'

export function ActivityComposition({ items }: { items: StateBreakdownItem[] }) {
  if (!items.length) return <div className="chart-empty">No state history is available.</div>
  return (
    <div className="composition">
      <div className="composition__bar" aria-label="Machine state composition">
        {items.map((item) => (
          <span
            key={item.state}
            className={`state-bg-${item.state}`}
            style={{ width: `${item.percentage}%` }}
            title={`${item.label}: ${formatPercent(item.percentage, 1)}`}
          />
        ))}
      </div>
      <div className="composition__list">
        {items.map((item) => (
          <div key={item.state}>
            <i className={`state-bg-${item.state}`} />
            <span>
              <strong>{item.label}</strong>
              <small>{formatHours(item.hours)}</small>
            </span>
            <b>{formatPercent(item.percentage, 1)}</b>
          </div>
        ))}
      </div>
    </div>
  )
}
